import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../../../Layout/Loader';
import { Navigate } from 'react-router-dom';
// import ErrorNoAccount from 'components/Error/ErrorNoAccount';
import setAuthCredentials from '../../setAuthCredentials';
import UserDataOnDemand from '../../../ApolloConnectors/UserData/UserDataConnectorApollo';
import { withTranslator } from '../../../I18n/withTranslator';
import LoginViaFacebookConnectorApollo from './Connector/Apollo/LoginViaFacebookConnectorApollo';
import AuthLoginByFacebookTokenWrapperComponent from './AuthLoginByFacebookTokenWrapperComponent';

class AuthLoginByFacebookTokenComponent extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  state = {
    isLoading: true,
    errors: [],
  };

  loginViaFacebook = async (loginViaFacebook, userDataOnDemand) => {
    const response = await loginViaFacebook;

    if (response.data.auth.loginViaFacebook.__typename === 'OauthException') {
      if (response.data.auth.loginViaFacebook.code === 401) {
        this.setState((prevState) => ({
          errors: [...prevState.errors, this.props.t('auth/login/user-not-exists')],
        }));
      }
    } else {
      const userToken = response.data.auth.loginViaFacebook.token;
      setAuthCredentials(userToken);
      await userDataOnDemand();
    }

    this.setState({ isLoading: false });
  };

  render() {
    const token = new URL(document.location.href).searchParams.get('code');
    const state = new URL(document.location.href).searchParams.get('state');
    const noAccountPath = '/auth/no-account';

    let returnPath = global.localStorage.getItem('redirectToPathAfterSuccess') || '/';

    if (state === 'stripe_login') {
      returnPath = '/buy';
    }

    if (state === 'cart_login') {
      returnPath = '/cart/save-payment';
    }

    return (
      <React.Fragment>
        <LoginViaFacebookConnectorApollo>
          {(result) => (
            <UserDataOnDemand>
              {(result2) => (
                <AuthLoginByFacebookTokenWrapperComponent
                  loginViaFacebook={() =>
                    this.loginViaFacebook(result.loginViaFacebook(token), result2.userDataOnDemand)
                  }
                />
              )}
            </UserDataOnDemand>
          )}
        </LoginViaFacebookConnectorApollo>

        {this.state.isLoading ? (
          <div className="full-height">
            <Loader />
          </div>
        ) : null}

        {!this.state.isLoading && !this.state.errors.length ? <Navigate to={returnPath} /> : null}

        {!this.state.isLoading && this.state.errors.length ? <Navigate to={noAccountPath} /> : null}
      </React.Fragment>
    );
  }
}

export default withTranslator(AuthLoginByFacebookTokenComponent);
